<template>
  <router-view/>
  <notifications position="top right" />
</template>

<script>
  export default {
    name: 'App',
    mounted() {
      window.localLang = this.$local
    }
  }
</script>

<style>
  .vs__dropdown-toggle {
    border : #000000;
  }
</style>